import { z } from 'zod';

export const errorMessages = {
  required: 'Dit veld is verplicht',
  onlyContainNumbers: 'Dit veld kan alleen maar nummers bevatten',
  maxSurface: (max: number) => `Dit veld kan niet meer dan ${max}m2 zijn`,
};

const voorzieningAmountValidation = z.coerce
  .number({
    message: errorMessages.onlyContainNumbers,
  })
  .min(1, 'Dit veld kan niet lager dan 1 zijn')
  .max(5, 'Dit veld kan niet hoger dan 5 zijn')
  .lte(100, errorMessages.maxSurface(100));

export const validations = {
  voorzieningAmount: voorzieningAmountValidation,
};
